import { render, staticRenderFns } from "./LabelFilter.vue?vue&type=template&id=3e6b3a11"
import script from "./LabelFilter.vue?vue&type=script&lang=js"
export * from "./LabelFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports